import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33ef1c61"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"margin":"10px 0 5px 0"} }, "Схемы погрузки", -1))
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "schemes" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "switchContainer mt-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Схема в 3D", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_PlanTransportGroupResultLoadingSchemeJournal = _resolveComponent("PlanTransportGroupResultLoadingSchemeJournal")!
  const _component_PlanTransportGroupResultSchemeInfo = _resolveComponent("PlanTransportGroupResultSchemeInfo")!
  const _component_DxSwitch = _resolveComponent("DxSwitch")!
  const _component_PlanTransportGroupResultScheme3D = _resolveComponent("PlanTransportGroupResultScheme3D")!
  const _component_PlanTransportGroupResultScheme = _resolveComponent("PlanTransportGroupResultScheme")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DxLoadPanel, {
        visible: _ctx.loading,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
        "show-indicator": true,
        "show-pane": true,
        shading: false,
        "close-on-outside-click": false
      }, null, 8, ["visible"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PlanTransportGroupResultLoadingSchemeJournal, {
          onContentReady: _ctx.onContentReady,
          onSelectionChanged: _ctx.onSelectionChanged,
          parentModel: _ctx.parentModel,
          parentEditingConfig: _ctx.parentEditingConfig
        }, null, 8, ["onContentReady", "onSelectionChanged", "parentModel", "parentEditingConfig"])
      ]),
      _createElementVNode("div", {
        id: _ctx.loadingSchemeDomId,
        class: "scheme-info"
      }, [
        (_ctx.model.scheme)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_PlanTransportGroupResultSchemeInfo, {
                ref: "reportFilter",
                model: _ctx.model
              }, null, 8, ["model"]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_DxSwitch, {
                  value: _ctx.scheme3D,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.scheme3D) = $event))
                }, null, 8, ["value"])
              ]),
              (_ctx.scheme3D)
                ? (_openBlock(), _createBlock(_component_PlanTransportGroupResultScheme3D, {
                    key: 0,
                    structure: _ctx.model.scheme.structure,
                    "rolls-list": _ctx.rollsList,
                    "pallets-list": _ctx.palletsList,
                    container: _ctx.container
                  }, null, 8, ["structure", "rolls-list", "pallets-list", "container"]))
                : (_openBlock(), _createBlock(_component_PlanTransportGroupResultScheme, {
                    key: 1,
                    model: _ctx.model
                  }, null, 8, ["model"]))
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_4)
    ])
  ], 64))
}